module.exports = __webpack_public_path__ + "img/payoutalert.ded6d5e4.svg";